import _classCallCheck from "/usr/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/usr/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var InternalServerError500Exception = /*#__PURE__*/function (_Error) {
  function InternalServerError500Exception(reason) {
    var _this;
    var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, InternalServerError500Exception);
    _this = _callSuper(this, InternalServerError500Exception, ["Internal Error"]);
    _defineProperty(_this, "name", "InternalServerError500Exception");
    _defineProperty(_this, "type", 'api error');
    _defineProperty(_this, "statusCode", 500);
    _this.trace = reason;
    return _this;
  }
  _inherits(InternalServerError500Exception, _Error);
  return _createClass(InternalServerError500Exception, null, [{
    key: "factoryFromAxios",
    value: function factoryFromAxios(res) {
      var _res$response, _res$response$data;
      var msg = res === null || res === void 0 ? void 0 : (_res$response = res.response) === null || _res$response === void 0 ? void 0 : (_res$response$data = _res$response.data) === null || _res$response$data === void 0 ? void 0 : _res$response$data.error;
      return new InternalServerError500Exception(msg);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export { InternalServerError500Exception as default };